import { trackHomeEvent } from '@/api/tracking';
import { userSession } from '@/utils/userSession';

export const shouldUseNextLayout = (): boolean =>
  !userSession.getUseLegacyLayout();

export const isOptedOutOfNextLayout = (): boolean =>
  userSession.getUseLegacyLayout();

export const switchLayout = async (useLegacy: boolean): Promise<void> => {
  userSession.setUseLegacyLayout(useLegacy);
  await trackHomeEvent(
    useLegacy ? 'legacy_layout_switch' : 'next_layout_switch',
    undefined,
  ).catch(() => {});
  // 旧デザインから新デザインへの切り替え時は、トップページに遷移させてからリロードする
  if (!useLegacy) {
    window.location.hash = '/';
  }
  window.location.reload();
};
